import axios from 'axios';

const config = {
  API_BASE_URL: process.env.REACT_APP_API_BASE_URL,
  API_KEY: process.env.REACT_APP_API_KEY,
  AI_BASE_URL: process.env.REACT_APP_AI_BASE_URL || process.env.REACT_APP_API_BASE_URL,
  NESTER_API_URL: process.env.REACT_APP_NESTER_API_URL,
};

// --- Global Axios Interceptor --
// Automatically attaches X-API-Key header to every axios request
axios.interceptors.request.use((requestConfig) => {
  if (config.API_KEY) {
    requestConfig.headers['X-API-Key'] = config.API_KEY;
  }
  return requestConfig;
});

// --- Global Fetch Wrapper ---
// Automatically attaches X-API-Key header to every fetch() call
// that targets our API. This avoids modifying 170+ files.
const originalFetch = window.fetch;
window.fetch = function(url, options = {}) {
  // Only add the header for requests to our API
  if (config.API_KEY && typeof url === 'string' && (url.includes(config.API_BASE_URL) || url.includes(config.AI_BASE_URL) || (config.NESTER_API_URL && url.includes(config.NESTER_API_URL)))) {
    options.headers = {
      ...options.headers,
      'X-API-Key': config.API_KEY
    };
  }
  return originalFetch.call(this, url, options);
};

export default config;